<template>
  <div class="work-detail">
    <h3 class="title">{{ worksData.name }}</h3>
    <div class="info-box">
      <div class="left l_flex_row">
        <div class="author">作者：{{ worksData.username }}</div>
        <div class="lb"></div>
        <div class="organ">参赛机构：{{ worksData.from }}</div>
        <div class="lb"></div>

        <div class="date">发表时间：{{ worksData.created_at }}</div>
      </div>
      <div class="right l_flex_row">
        <span @click="addWorksMark" class="icon l_flex_row">
          <span class="iconfont icon-good"></span>
          <span class="icon_text">{{ worksData.mark }}</span>
        </span>
<!--        <span class="icon l_flex_row">-->
<!--          <span class="iconfont icon-pinglun"></span>-->
<!--          <span class="icon_text">{{ worksData.comment }}</span>-->
<!--        </span>-->
        <span class="icon l_flex_row">
          <span class="iconfont icon-browse"></span>
          <span class="icon_text">{{ worksData.views }}</span>
        </span>
      </div>
    </div>
    <div class="work-content">
      <component :data="worksData" :is="componentId"></component>
    </div>
    <div v-if="false" class="titlebar">
      <div class="tl"></div>
      <h4 class="tb_title">评论（{{ worksData.comment }}）</h4>
    </div>
    <!-- 评论 -->
    <div v-if="false" class="comment">
      <el-form ref="form" :rules="rules" :model="formData" label-width="0px">
        <el-form-item label="" prop="commentText">
          <el-input
            :autosize="{ minRows: 4, maxRows: 10 }"
            placeholder="请输入评论"
            type="textarea"
            v-model="formData.commentText"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="l_flex_row_end">
          <el-button @click="submitComment" class="submit_btn" type="primary">提交评论</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 评论列表 -->
    <div v-if="false" class="comment-list" v-infinite-scroll="load" style="overflow:auto">
      <comment-item :obj="item" v-for="(item, index) in commentList" :key="index"></comment-item>
    </div>
    <!-- empty -->
    <el-empty v-if="isEmpty" description="暂无评论"></el-empty>
  </div>
</template>

<script>
import CommentItem from "./component/CommentItem.vue";
export default {
  components: {
    CommentItem,
  },
  props: {
    type: String,
    worksId: String,
    loginType: {
      type: String,
      default: "user",
    }, // admin | user
  },
  data() {
    return {
      componentId: "",
      formData: {
        commentText: "",
      },
      rules: {
        commentText: [
          {
            required: true,
            message: "请输入评论",
            trigger: "blur",
          },
        ],
      },
      commentList: [],
      worksData: {},
      pageSize: 2,
      currentPage: 1,
      total: 10,
      hasNext: true,
    };
  },
  watch: {},
  computed: {
    isShowComment() {
      return this.loginType == "user";
    },
    // 是否显示空状态
    isEmpty(){
      return this.total == 0;
    }
  },
  methods: {
    // 发表评论
    submitComment() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("submit");
          this.$api
            .addWorksComment({
              params: {
                "access-token": localStorage.getItem("token"),
              },
              data: {
                activity_id: this.worksData.activity_id,
                activity_works_id: this.worksId,
                comment: this.formData.commentText,
              },
            })
            .then((res) => {
              //
              this.formData.commentText = "";
              //
              this.$message.closeAll();
              this.$message({
                message: res.message,
                type: "success",
                offset:300,
            duration:2000
              });
            })
            .catch((err) => {
              //
            });
        } else {
          console.log("err");
        }
      });
    },
    // 获取作品详情
    async getWorksDetail() {
      try {
        const res = await this.$api.getWorksDetail({
          params: {
            "access-token": localStorage.getItem("token"),
            id: this.worksId,
            
          },
        });
        console.log("res", res);
        this.worksData = res.data;
      } catch (error) {
        console.log("err", error);
      }
    },
    // 获取评论列表
    async getCommentList(page = 1) {
      try {
        const res = await this.$api.getWorksCommentList({
          params: {
            "access-token": localStorage.getItem("token"),
            page: page,
            "per-page": this.pageSize,
          },
          data: {
            activity_works_id: this.worksId,
          },
        });
        this.commentList = page == 1 ? res.data.comment_list : [...this.commentList, ...res.data.comment_list];
        this.hasNext = this.commentList.length < res.data.comment_num ? true : false;
        this.total = res.data.comment_num;
      } catch (err) {}
    },
    // 上拉加载
    load() {
      console.log("load");
      if (this.hasNext) {
        // this.getCommentList(this.currentPage);
        this.currentPage += 1;
      }
    },
    // 
    async addWorksMark(){
      try {
        const res = await this.$api.addWorksMark({
          params: {
            'access-token': localStorage.getItem('token')
          },
          data:{
            activity_id: this.worksData.activity_id,
            activity_works_id: this.worksId
          }
        });
        this.$message.closeAll();
        this.$message({
          message: res.message,
          type: 'success',
          offset:300,
            duration:2000
        })

      } catch (error) {
        
      }
    }
  },
  created() {
    // this.getCommentList();
    this.getWorksDetail();
    // this.getCommentList();
  },
  mounted() {
    // 动态注册组件
    /* 
    1;//音频类
    2;//视频类
    3;//文本类
    4;//图片类
    5;//打卡类
    */
    const rules = {
      "3": () => {
        return () => import("./component/RichText.vue");
      },
      "1": () => {
        return () => import("./component/WorkAudio.vue");
      },
      "2": () => {
        return () => import("./component/WorkVideo.vue");
      },
    };
    this.componentId = rules[this.type]();
  },
};
</script>
<style lang="scss" scoped>
.work-detail {
  font-size: 15px;
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  .title {
    font-size: 26px;
  }
  .info-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // font-size: 14px;
    color: #606266;
    .left {
      .lb {
        width: 2px;
        height: 18px;
        background-color: #999;
        margin: 0 15px;
      }
    }
    .right {
      color: #606266;
      .icon {
        margin-right: 10px;
        &:first-child {
          cursor: pointer;
        }
        .iconfont {
          font-size: 18px;
        }
        .icon_text {
          margin: 0 10px 0 5px;
        }
      }
    }
  }
  .work-content {
    padding: 30px;
    min-height: 200px;
    background-color: #fff;
    margin: 40px 0;
    border-radius: 10px;
  }
  .titlebar {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #815a4e;
    .tl {
      width: 8px;
      height: 24px;
      border-radius: 5px;
      background-color: #815a4e;
      margin-right: 40px;
    }
  }
  .comment {
    .submit_btn {
      background-color: #815a4e;
      border-color: #815a4e;
    }
  }
  .comment-list {
    // height: 80vh;
    // max-height: 200px;
    max-height: 80vh;
  }
}
</style>
